import { api } from "jiffy-api";
import EventClass from "common/utils/ui/event-class";
import { isPhone, isMobileBrowser, isTablet, isBare } from "common/utils/browser";
import { initMixpanelEvents } from "common/utils/mixpanel/init-mixpanel-events";
import { initSameDayBadgesForMasthead } from "components/jiffy/products/product-composition-estimates";

export default class MobileMenuClass extends EventClass {
  #scrollPosition = {};

  constructor(
    props = {
      eventSelector: "",
      contentWrapperSelector: "",
      bannerWrapperSelector: "",
      menuWrapperSelector: "",
      buttonActiveClass: "",
      submenuActiveClass: ""
    }
  ) {
    super(props);
    this.props = props;
  }

  get #$menuWrapper() {
    return document.querySelector(this.props.menuWrapperSelector);
  }

  get #$contentWrapper() {
    return document.querySelector(this.props.contentWrapperSelector);
  }

  get #$bannerWrapper() {
    return document.querySelector(this.props.bannerWrapperSelector);
  }

  get #$activeTriggerButtons() {
    return this.#$menuWrapper.querySelectorAll(
      `${this.props.eventSelector}.${this.props.buttonActiveClass}`
    );
  }

  event(event, $button) {
    super.event(event, $button);

    const { direction, level } = $button.dataset;

    if (direction === "back") {
      const $lastSubmenu = Array.from(this.#$activeTriggerButtons).at(-1);
      $lastSubmenu.classList.remove(this.props.buttonActiveClass);

      if (level === "1") {
        this.#$menuWrapper.classList.remove(this.props.submenuActiveClass);
      }

      const prevLevel = String(level - 1);
      this.#$menuWrapper.scroll(0, this.#scrollPosition[prevLevel]);
    } else {
      $button.classList.add(this.props.buttonActiveClass);
      this.#scrollPosition[level] = this.#$menuWrapper.scrollTop;
      this.#$menuWrapper.scroll(0, 0);

      if (level === "0") {
        this.#$menuWrapper.classList.add(this.props.submenuActiveClass);
      }
    }

    const currentTransition = -100 * level;
    const shift = direction === "forward" ? -100 : 100;
    this.#$contentWrapper.style.transform = `translate3d(${currentTransition + shift}%, 0, 0)`;
  }

  #updateMenuWithHtml({ html }) {
    this.#$contentWrapper.innerHTML = html;

    initMixpanelEvents(
      this.props.menuWrapperSelector,
      "[data-mixpanel-event][data-mixpanel-listen]"
    );

    initSameDayBadgesForMasthead();
  }

  #updateBannerWithHtml({ html }) {
    this.#$bannerWrapper.innerHTML = html;
  }

  loadMenu() {
    if (isBare()) return;

    const isMobile = () => isPhone() || isMobileBrowser() || isTablet();
    const getMenu = () => {
      if (!isMobile()) return;
      api.menu.fetchMobileMenu().then(this.#updateMenuWithHtml.bind(this));
      if (this.#$bannerWrapper) {
        api.menu.fetchMobileBanner().then(this.#updateBannerWithHtml.bind(this));
      }
      window.removeEventListener("resize", getMenu, true);
    };

    getMenu();
    !isMobile() && window.addEventListener("resize", getMenu, true);
  }

  resetScrollPosition() {
    this.#scrollPosition = {};
    this.#$menuWrapper.scroll(0, 0);
    this.#$contentWrapper.style.transform = `translate3d(0, 0, 0)`;
    this.#$menuWrapper.classList.remove(this.props.submenuActiveClass);
    this.#$activeTriggerButtons.forEach($submenu =>
      $submenu.classList.remove(this.props.buttonActiveClass)
    );
  }
}
